import html from "../assets/html.png";
import css from "../assets/css.png";
import js from "../assets/js.png";
import react from "../assets/react.png";
import bootstrap from "../assets/bootstrap.png";
import tailwind from "../assets/tailwind.png";
import petra from "../assets/gallery/petra.jpg";
import rome from "../assets/gallery/rome.jpg";
import barcelona from "../assets/gallery/barcelona.jpg";
import marrakech from "../assets/gallery/marrakech.jpg";
import manhattan from "../assets/gallery/manhattan.jpg";
import cairo from "../assets/gallery/cairo.jpg";
import cappadocia from "../assets/gallery/cappadocia.jpg";
import damascus from "../assets/gallery/damascus.jpg";
const data = [
  { id: 1, skill: "html", img: html },
  { id: 2, skill: "css", img: css },
  { id: 3, skill: "js", img: js },
  { id: 4, skill: "bootstrap", img: bootstrap },
  { id: 5, skill: "tailwind", img: tailwind },
  { id: 6, skill: "react js", img: react },
];
export default data;

export const galleryImg = [
  {
    id: 1,
    title: "Petra",
    description:
      "The Treasury, the most famous site in Petra ancient city in Jordan",
    image: petra,
  },
  {
    id: 2,
    title: "Rome",
    description:
      "The famous Collesium of Rome, a world wonder and a must visit ",
    image: rome,
  },
  {
    id: 3,
    title: "Barcelona",
    description:
      "A beautiful view of barcelona city from the sky with La Sagrada Familia",
    image: barcelona,
  },
  {
    id: 4,
    title: "Marrakech",
    description:
      "Marrakech, Morroco's magical city with a lot of morrocan culture",
    image: marrakech,
  },
  {
    id: 5,
    title: "Manhattan",
    description:
      "Manhattan, the big apple, the city of skyscrapers that never sleeps",
    image: manhattan,
  },
  {
    id: 6,
    title: "Damascus",
    description: "Damascus old town with Amawi Mosque in the center",
    image: damascus,
  },
  {
    id: 7,
    title: "Cairo",
    description: "A small part of the beautiful and busy city of Cairo",
    image: cairo,
  },
  {
    id: 8,
    title: "Cappadocia",
    description:
      "Riding a baloon in Cappadocia is definitely an amazing experience",
    image: cappadocia,
  },
];
